export default __webpack_public_path__ + "static/media/icone-splash-mulher-sentada.7a662af0.svg";